import TrelloModel from 'app/scripts/models/internal/trello-model.coffee';

class CustomSticker extends TrelloModel {
  static initClass() {
    this.prototype.typeName = 'CustomSticker';
  }
}
CustomSticker.initClass();

export { CustomSticker };
